/**
 * Interview Domain Types
 *
 * Core types related to interview sessions, status, and chat messages.
 */

export enum InterviewStatus {
  IDLE = 'IDLE',
  SETUP = 'SETUP',
  CONNECTED = 'CONNECTED',
  ENDED = 'ENDED',
}

/**
 * Interview Mode - determines the interview experience type
 * - 'ai': Conversational AI interview using Gemini Live (AI speaks and listens)
 * - 'question_set': Sequential recording mode (questions displayed one by one, no live AI)
 */
export type InterviewMode = 'ai' | 'question_set'

export interface ChatMessage {
  role: 'user' | 'model'
  text: string
  timestamp: string // ISO 8601 format for proper JSON serialization
}

/**
 * Question Response - Per-question recording data for Sequential interview mode
 *
 * Represents a candidate's video response to a single interview question,
 * including the recording URL, transcript, and timing metadata.
 */
export interface QuestionResponse {
  id: string
  interviewId: string
  questionId?: string | null
  questionOrder: number
  questionText: string
  recordingUrl?: string | null
  recordingKey?: string | null
  recordingDurationSeconds?: number | null
  recordingSizeBytes?: number | null
  recordingMimeType?: string | null
  muxAssetId?: string | null
  muxPlaybackId?: string | null
  muxUploadId?: string | null
  transcript?: string | null
  startedAt?: string | null // ISO 8601
  completedAt?: string | null // ISO 8601
  createdAt?: string
  updatedAt?: string
}

/**
 * Request payload for creating/updating a question response
 */
export interface CreateQuestionResponseRequest {
  questionId?: string
  questionOrder: number
  questionText: string
  recordingUrl?: string
  recordingKey?: string
  recordingDurationSeconds?: number
  recordingSizeBytes?: number
  recordingMimeType?: string
  muxAssetId?: string
  muxPlaybackId?: string
  muxUploadId?: string
  transcript?: string
  startedAt?: string
  completedAt?: string
}
